import { useQuery } from "@tanstack/react-query";
import api from "../api"; // axios instance

interface TicketAnalytics {
  tickets: {
    new_tickets_count: string;
    unassigned_tickets_count: string;
    ongoing_tickets_count: string;
    resolved_tickets_count: string;
    closed_tickets_count: string;
  }[];
  performance: {
    team: string;
    assigned_tickets_count: string;
    closed_tickets_count: string;
  }[];
  callTypes: {
    call_type_name: string;
    service_id: string;
    count: string;
  }[];
}

export const useTicketsAnalytics = (selected_period: string) => {
  return useQuery({
    queryKey: ["ticketsAnalytics", selected_period],
    queryFn: async () => {
      const { data } = await api.get(
        `/servcie-request-analytics-admin/v1?selected_period=${selected_period}`
      );
      return data.data as TicketAnalytics;
    },
    staleTime: 1000 * 60 * 5, // 5 minutes cache
  });
};
